// extracted by mini-css-extract-plugin
export var infoItem = "_of-2";
export var title = "_of-0";
export var value = "_of-1";